module.exports = __webpack_public_path__ + "static/media/card-game-info.36a833d6.png";